import api from "./api"
import { TreeType } from "../types"

export const treeTypeService = {

  async getAll(): Promise<TreeType[]> {
    const { data } = await api.get("/tree-types")
    return data.tree_types
  },

  async createBulk(types: { name: string; color_hex?: string }[]) {
    const { data } = await api.post("/tree-types", { tree_types: types })
    return data
  },

  async update(id: number, payload: {
    name: string
    color_hex?: string
    is_active?: boolean
  }): Promise<TreeType> {
    const { data } = await api.put(`/tree-types/${id}`, payload)
    return data.tree_type
  },

  async delete(id: number): Promise<void> {
    await api.delete(`/tree-types/${id}`)
  },
}